export function setStepAsCompleated(stepJson, json, guideContainer) {
  // find item in stepJson with contentKey === json.id and set isCompleted to true
  stepJson.filter((item) => item.contentKey === json.id)[0].isCompleted = true;
  //find span in item in stepButtons with [data-currentstep]
  let currentStepSpan = guideContainer.querySelector(`[data-currentstep] span`);
  currentStepSpan.classList.add("bg-blue");
  currentStepSpan.classList.add("text-white");
  return setStepAsCompleated;
}
